import Axios from 'axios';
import serviceUtil from './serviceUtil';

/**
 * 
 * @param {number} projectTemplateId - required
 * 
 * The following params are sent through the options object:
 *   @param {string} projectStatuses - comma delimited list of statuses (e.g. 'not_started,in_progress')
 *   @param {string} projectName - project name search string
 *   @param {number} page 
 *   @param {number} perPage 
 */
function getProjectAnalysis(projectTemplateId, options) {
  const { page, perPage, projectStatuses } = options;
  
  let url = process.env.REACT_APP_API + '/analytics/project_analysis/' + projectTemplateId + '?current_company=' + localStorage.current_company_id
    + (projectStatuses ? '&project_status='+projectStatuses : '')
    + ((page && perPage) ? '&page=' + page + '&per=' + perPage : '');
  
  if (options.marketIds) {
    url += '&markets=' + options.marketIds.join(',');
  }
  
  return Axios({
    method: 'get',
    url,
    timeout: 120000,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Token token=' + localStorage.token,
    },
  }).then(response => {
    return response.data;
  }).catch(error => {
    return serviceUtil.resultForError(error);
  });
}

export default {
  getProjectAnalysis,
};



// WEBPACK FOOTER //
// ./src/services/projectAnalysisService.js